<template>
  <div>
    <div class="enter">
      <!-- 1.信电查入口 -->
      <div class="right">
        <img
          style="height: 320px; width: 100%; overflow: hidden"
          src="../../assets/jianjieBgc.png"
          alt=""
        />
      </div>
    </div>
    <!-- 导航 -->
    <navigate :daohangshuju="daohangshuju" />

    <!-- 2.产品介绍，图文混排 -->
    <div class="product contentCss">
      <div class="hoverImage">
        <HoverImage
          style="width: 85%"
          :imageSrc="chanpin1"
          imageAlt="信电查"
        ></HoverImage>
      </div>
      <div class="presentation needLeft">
        <h3>电力征信“数据字典”</h3>
        <div class="text">
          <p>
            汇集营商数据，整合公共信用数据和电力征信专业数据，建立统一的外部接入标准，服务管理与运营分析一体化，全面专业满足大企业获取外部营商数据的需求，推动企业数字化转型。
          </p>
        </div>
      </div>
    </div>
    <div class="product contentCss">
      <div class="presentation">
        <h3 class="pointerCss" @click="reportClick">商务信用评价“卡尺”</h3>

        <div class="text">
          <p>
            依托涉电力领域市场主体信用评价的应用和标准体系，研发商务评价模型度量集团外部企业商务信用。对涉电力领域市场主体在电力生产服务过程中，以遵守法律规范、承担社会责任、履行相关合约的意愿、能力和表现进行评分，综合评价目标企业的经营能力、科技水平、产品认证、服务履约等全方面资质。为供应商企业开展招标审核、集采入库提供标准工具；为企业供应商分类管理提供评价依据；辅助企业实现供应商动态监管、金融信贷等。
          </p>
        </div>
      </div>
      <div class="hoverImage">
        <HoverImage
          class="RightImg"
          style="width: 85%"
          :imageSrc="chanpin2"
          imageAlt="哈哈"
        ></HoverImage>
      </div>
    </div>
    <div class="product contentCss">
      <div class="hoverImage">
        <HoverImage
          style="width: 85%"
          :imageSrc="chanpin3"
          imageAlt="信电查"
        ></HoverImage>
      </div>
      <div class="presentation needLeft">
        <h3 class="pointerCss" @click="xydlzsClick">信用电力指数“风向标”</h3>
        <div class="text">
          <p>
            在建立健全以信用为基础的新型监管机制过程中，依托信用电力指数全面、系统、实时、动态表征集团型企业（或行业型组织）信用体系建设与管理情况，帮助企业了解指数监测排名状况，定向改进，提升企业站位。实现集团对下属企业或子企业全维度监测，提升企业管理效率。企业依据指标模型和自评价结果，了解自身管控缺陷，提升管控水平。
          </p>
        </div>
      </div>
    </div>
    <div class="product contentCss">
      <div class="presentation">
        <h3 class="pointerCss" @click="dxcClick">电力征信查询“信电查”</h3>
        <div class="text">
          <p>
            全方位综合性商业查询Saas平台。从行业监管出发、依托行业的征信资质优势，整合市场化大数据资源并以电力行业专有数据为特色，面向社会推出的商业信息查询及分析服务。
          </p>
        </div>
      </div>
      <div class="hoverImage">
        <HoverImage
          class="RightImg"
          style="width: 85%"
          :imageSrc="chanpin4"
          imageAlt="哈哈"
        ></HoverImage>
      </div>
    </div>
    <div class="product contentCss">
      <div class="hoverImage">
        <HoverImage
          style="width: 85%"
          :imageSrc="chanpin5"
          imageAlt="信电查"
        ></HoverImage>
      </div>
      <div class="presentation needLeft">
        <h3 @click="jrfwClick">电力供应链产业金融服务平台</h3>
        <div class="text">
          <p>
            围绕涉电力企业，依据中标数据、税票数据、企业和企业主的多维度数据，建立电力供应链信用体系，管理上下游中小企业的资金流、信息流，并把单个企业的不可控风险转变为供应链企业整体的可控风险，通过专业风控模型。实现基于信用的核额放款授信模式，为体系类的中小企业融资提供便利，为合作资金方提供优质资产。
          </p>
        </div>
      </div>
    </div>

    <!-- <div class="xdcSearch">
      <el-link type="primary" :underline="false" href="" target="_blank"
        >信电查入口</el-link
      >
    </div> -->
  </div>
</template>

<script>
import chanpin1 from '@/assets/chanpin1.jpg'
import chanpin2 from '@/assets/chanpin2.jpg'
import chanpin3 from '@/assets/chanpin3.jpg'
import chanpin4 from '@/assets/chanpin4.jpg'
import chanpin5 from '@/assets/chanpin5.jpg'
import ckPng from '@/assets/logo.png'
import HoverImage from "@/components/HoverImage/index"
// 导航组件
import navigate from '@/components/navigate'
export default {
  name: 'vuecomponent',
  components: {
    HoverImage,
    navigate
  },
  data () {
    return {
      chanpin1,
      chanpin2,
      chanpin3,
      chanpin4,
      chanpin5,
      ckPng,
      searchInput: '',
      activeMenu: '',
      daohangshuju: '产品简介',
      bannerList: [
        {
          id: 1,
          content: 'https://www.cecdlzx.com/oss/owms/26E5A26B9230CD01A4B1A1C44EC225BD/257f8ab88f9445b98f9c2826c3203e45.png',
          url: "https://www.cecdlzx.com/owms/#/home"
        },
        {
          id: 2,
          content: 'https://www.cecdlzx.com/oss/owms/26E5A26B9230CD01A4B1A1C44EC225BD/576e0a8c10f1459797aced9ca904efd1.png',
          url: "https://www.cecdlzx.com/dlzx/#/electric"
        },
        {
          id: 3,
          content: 'https://www.cecdlzx.com/oss/owms/26E5A26B9230CD01A4B1A1C44EC225BD/77b7d0be5ebc43ad94854b7863386d4c.png',
          url: "https://www.cecdlzx.com/dlzx/#/login"
        },
      ],
      key: "value",
    }
  },
  methods: {
    reportClick () {
      this.$router.push('/report')
      location.reload()
    },
    xydlzsClick () {
      this.$router.push('/cecIndex')
      location.reload()
    },
    dxcClick () {
      this.$router.push('/xdc')
      location.reload()
    },
    jrfwClick () {
      this.$router.push('/financial')
      location.reload()
    }
  },
}
</script>

<style lang="less" scoped>
.bannerImg {
  height: 260px;
}

.product {
  .hoverImage {
    width: 40%;
    display: inline-block;
    vertical-align: middle;
  }

  .presentation {
    text-align: left;
    width: 60%;
    display: inline-block;
    vertical-align: middle;
    h3 {
      margin-bottom: 20px;
      color: #00489d;
      font-size: 18px;
    }

    .text {
      line-height: 1.8;
      .tuchu {
        font-size: 16px;
        font-weight: 700;
      }
    }
  }

  .needLeft {
    // margin-left: -60px;
  }
}

.partner {
  // margin: 10px 0;

  .title {
    text-align: center;
    position: relative;

    p {
      font-size: 48px;
      font-weight: bold;
      color: rgba(153, 154, 155, 0.3);
    }

    h2 {
      font-size: 36px;
      position: absolute;
      margin: 0;
      left: 45%;
      top: 35px;
    }
  }

  .list {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    span {
      width: 150px;
      height: 60px;
    }
  }
}

.enter {
  overflow: hidden;
  position: relative;
  // padding: 10px;
  width: 100%;
  height: 350px;
  .right {
    width: 100%;
  }
  .last {
    margin-left: 80px;
    width: 100%;
    position: absolute;
    top: 260px;
    .smallBox {
      font-size: 16px;
      width: 180px;
      height: 50px;
      color: #fff;
      border-radius: 5px;
      padding: 10px;
      text-align: center;
      line-height: 45px;
      height: 60px;
      border: 2px solid #53aee7;
      background: #53aee7;
      box-shadow: 0 1px 1px #53aee7, 0 2px 2px #53aee7, 0 3px 3px #53aee7,
        0 4px 4px #53aee7, 0 5px 5px #53aee7;
      transform-origin: 50% 50%;
      /* 设置过渡动画 */
      transition: all 1s;
    }
  }
}
.smallBox:hover {
  /* 鼠标移动上去后  */
  transform: scale(1.2, 1.2);
}
.xdcSearch {
  margin: 10px auto;
  height: 45px;
  line-height: 45px;
  border-radius: 5px;
  text-align: center;
  border: 1px solid #53aee7;
  width: 150px;
}

.pointerCss {
  cursor: pointer;
}

.RightImg {
  margin-left: 60px;
}
</style>
